export default __webpack_public_path__ + "6275d7dc58ac5cbdad078b438ea1fad1.svg";